module.exports = __webpack_public_path__ + "img/bg5.661d3732.webp";